import React from 'react';
import { Box, Typography, Tooltip, Fab } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import ChipFilter from '../../../../components/filters/ChipFilter';
import styles from './OperatorExportFilters.styles';

export default function OperatorExportFilters({
  filters,
  setFilters,
  operatorOptions,
  onExport,
}) {
  const toggleFilter = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((o) => o !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => {
    setFilters((prev) => ({ ...prev, [type]: [] }));
  };

  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Filters:</Typography>

        <ChipFilter
          label="Code"
          type="operator"
          values={operatorOptions}
          selectedValues={filters.operator}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />
      </Box>

      <Box sx={styles.rightControls}>
        <Tooltip title="Export to CSV" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onExport}>
            <FileDownloadIcon fontSize="small" />
          </Fab>
        </Tooltip>

      </Box>
    </Box>
  );
}
